import axios from "axios";
import LocalStorageService from "./local-storage.service";
import { toast } from "react-toastify";
import { getAccountsUrl } from "../../utils/accountsUrl";
// import router from "./router/router";

// LocalstorageService
const localStorageService = LocalStorageService.getService();

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    if (localStorageService.getAccessToken()) {
      const token = localStorageService.getAccessToken();
      if (token) {
        config.headers["ssoToken"] = token;
      }
    }
    if (localStorageService.getSessionID()) {
      const session_id = localStorageService.getSessionID();
      config.headers["sessionId"] = session_id;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (!!error && !!error.response && error.response.status === 401) {
      const salesforceParams = window.location.search;
      //    redirecting user to login
      toast.error("Your session has been expired. Please login again");
      localStorageService.clearCompleteStorage();
      window.location =
        salesforceParams.company_id && salesforceParams.company_id !== ""
          ? getAccountsUrl() + "?&authentication=false&redirectFrom=salesforce&" + salesforceParams.replace("?", "")
          : getAccountsUrl() + "?&authentication=false";
      return Promise.reject(error);
    }
    if (!!error && !!error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorageService.getRefreshToken();
      return axios
        .post("/auth/token", {
          refresh_token: refreshToken,
        })
        .then((res) => {
          if (res.status === 201) {
            localStorageService.setToken(res.data);
            axios.defaults.headers.common["Authorization"] = "Bearer " + localStorageService.getAccessToken();
            return axios(originalRequest);
          }
        });
    }
    return Promise.reject(error);
  }
);
